/* QubCommon Imports */
import ToolbarExplorer from "qubCommon/ExplorerToolbar";
import Dropdown from "qubCommon/Inputs/Dropdown";
import useToolbarProps from "qubCommon/ExplorerToolbar/useToolbarProps";

/* Other project imports */
import ButtonProvoli from "components/Buttons/ButtonProvoli";

/* APIs */

import { menuKeyLogsExpl } from "api/MenuKeys";

/* React, MUI, Redux, react-hook-forms */
import { Grid, Box, Typography } from "@mui/material";
import { FormProvider } from "react-hook-form";
import format from "date-fns/format";
import React, { useState, useEffect } from "react";

/*Wijmo Imports*/
import { FlexGrid } from "@grapecity/wijmo.react.grid";
import { AllowResizing } from "@grapecity/wijmo.grid";
import useLogsExplorer from "./useLogsExplorer";

/* CSS */
import "./index.css";
import DateTimeInput from "qubCommon/Inputs/DateTimeInput";
import QubGenGrid from "qubCommon/Grids/QubGenGrid";
import QubGroupGrid from "qubCommon/Grids/QubGroupGrid";
import TextInput from "qubCommon/Inputs/TextInput";
import JsonDialog from "./Components/JsonDialog";

const LogsExplorer = () => {
  const [gridColumns, setGridColumns] = useState([]);

  const {
    toolbarRef,
    gridRef,
    gridData,
    gridInitialized,
    gridLoadedRows,
    onSubmit,
    excelHandleClick,
    form,
    explParams,
    handleSubmit,
    rowData,
    setRowData,
    rowDialog,
    setRowDialog,
  } = useLogsExplorer();

  const {
    csvFiles,
    pdfFiles,
    excelFiles,
    columns,
    // criteriaRef,
    // critParams,
    status,
  } = useToolbarProps({ webPageKey: "eShop-Logs-Expl" });

  const toolbarProps = { csvFiles, pdfFiles, excelFiles, columns };

  useEffect(() => {
    const helpCols = [];

    if (Array.isArray(columns) && columns?.length > 0) {
      columns.forEach((column) =>
        column.children.forEach((child) =>
          helpCols.push({
            binding: child.fldName,
            header: child.fldTitle,
            visible: child.isVisible,
            format: child.fldFormat,
          })
        )
      );
      setGridColumns(helpCols);
    } else setGridColumns([]);
  }, [columns]);

  const submit = () => handleSubmit(onSubmit)();
  console.log(explParams);

  return (
    <>
      <JsonDialog
        rowData={rowData}
        rowDialog={rowDialog}
        setRowData={setRowData}
        setRowDialog={setRowDialog}
      />
      <FormProvider {...form}>
        <Grid container sx={{ paddingLeft: 2, paddingRight: 2 }}>
          <Grid container item xs={12}>
            <ToolbarExplorer
              webPageKey={menuKeyLogsExpl}
              excelHandleClick={excelHandleClick}
              gridRef={gridRef}
              ref={toolbarRef}
              form={form}
              toolbarProps={toolbarProps}
              title={"Αρχεία Καταγραφής"}
            />
          </Grid>
          <Grid
            container
            spacing={2}
            flexDirection="row"
            sx={{ display: "flex", padding: 2, gap: 2 }}
          >
            <DateTimeInput
              sx={{ width: 200 }}
              name="dateFrom"
              label="Απο Ημ/νία"
              defaultDate={format(new Date(), "yyyy-MM-dd")}
              defaultTime="0:00"
            />
            <DateTimeInput
              sx={{ width: 200 }}
              defaultDate={format(new Date(), "yyyy-MM-dd")}
              name="dateTo"
              label="Εως Ημ/νία"
              defaultTime="23:59"
            />
            {explParams?.Status && (
              <Dropdown
                name="Status"
                label="Κατάσταση"
                options={explParams?.Status}
                defaultValue={explParams?.SelectedValueStatus}
              />
            )}
            {explParams?.Type && (
              <Dropdown
                name="Type"
                label="Τύπος"
                options={explParams?.Type}
                defaultValue={explParams?.SelectedValueType}
              />
            )}
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-end",
              }}
            >
              <ButtonProvoli handleClick={submit} />
            </Box>
          </Grid>
        </Grid>
        <QubGenGrid
          id="theGrid"
          style={{ height: "99%" }}
          initialized={gridInitialized}
          loadedRows={gridLoadedRows}
          gridData={gridData?.items}
          columns={gridColumns}
          className="explorer-grid"
        />
        {/* <QubGroupGrid
          id="theGrid"
          style={{ height: "99%" }}
          initialized={gridInitialized}
          loadedRows={gridLoadedRows}
          rows={gridData?.items}
          columns={columns}
        /> */}
      </FormProvider>
    </>
  );
};

export default LogsExplorer;
